require 'angular'

angular.module('workflow.api')
  .config ($httpProvider) ->
    # django and angular both support csrf tokens. This tells
    # angular which cookie to add to what header.
    $httpProvider.defaults.xsrfCookieName = 'csrftoken'
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken'
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

    interceptor = () ->
      service = {
        request: (config) ->
          if config.method == "PUT"
            config.headers['X-HTTP-Method-Override'] = "PATCH"
            config.headers['X-HTTP-Method'] = "PATCH"
          return config
      }
      return service

    $httpProvider.interceptors.push(interceptor)
